import styled from "@emotion/styled";

export const StyledCheckbox = styled.div`
  label: StyledCheckbox;
  --space-sm: 0.8rem;
  --color-charcoal-60: #21212199;
  --gradient-dusk: linear-gradient(
    90deg,
    #0e3763 0%,
    #5b4855 52.6%,
    #8a6947 100%
  );

  border-radius: 4px;
  padding: calc(var(--space-sm) * 0.125);
  cursor: pointer;
  -webkit-appearance: none;
  appearance: none;
  background-color: transparent;
  margin: 0 0.5em 0 0;
  --width: calc(var(--space-sm) * 1.5);
  --height: calc(var(--space-sm) * 1.5);
  width: var(--width);
  height: var(--height);
  min-width: var(--width);
  min-height: var(--height);
  --boder-color: var(--color-charcoal-60);
  // border: 1px solid var(--boder-color);
  box-shadow: 0 0 0 1px var(--boder-color);
  transform: translateY(0);
  display: grid;
  /* aligning ::before horizontally and vertically */
  place-content: center;
  position: relative;
  outline-offset: 2px;
  transition: all 0.2s ease-in-out;

  &:hover:not(label:[aria-isabled="true"]) {
    --boder-color: var(--color-charcoal-80, #212121cc);
    transform: scale(1.05);
  }

  &::before {
    content: "";
    transform: scale(0);
    transition: transform 0.12s ease-in-out;
  }

  &::after {
    content: "";
    position: absolute;
    z-index: -1;
  }

  label[data-selected="true"] & {
    box-shadow: 0 0 0 1px transparent;
    border: none;
    background: var(
      --gradient-blue-orange,
      linear-gradient(89.59deg, #80aeff 0.36%, #f7bde6 52.67%, #ffbd70 99.65%)
    );

    &::after {
      border-radius: 3px;
      top: 1px;
      bottom: 1px;
      left: 1px;
      right: 1px;
      background: var(--checkbox-inner-layer-bg, #ffffff88);
    }

    &::before {
      transform: scale(0.8);
      content: url('data:image/svg+xml;utf8, <svg width="18" height="13" viewBox="0 0 18 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" clipRule="evenodd" d="M17.1883 1.76986L15.669 0.298096L6.22459 9.76751L1.78081 5.32373L0.287109 6.76924L6.22463 12.7068L17.1883 1.76986Z" fill="url(%23paint0_linear_959_607)"/><defs><linearGradient id="paint0_linear_959_607" x1="0.287109" y1="6.50243" x2="17.1883" y2="6.50243" gradientUnits="userSpaceOnUse"><stop stopColor="%230E3763"/><stop offset="0.526042" stopColor="%235B4855"/><stop offset="1" stopColor="%238A6947"/></linearGradient></defs></svg>');
      position: absolute;
      inset: 0;
      height: 100%;
      display: grid;
      margin-top: 1px;
      margin-left: 1px;
      place-content: center;
    }
  }

  label[data-disabled="true"] & {
    cursor: not-allowed;
    opacity: 0.6;
  }

  label[data-invalid="true"] & {
    --boder-color: var(--primary-warning-red, #bf1902);
  }
`;

export const CheckboxFieldError = styled.div`
  padding: 0.5em 1em 1em;
  display: block;
  color: var(--primary-warning-red, #bf1902);

  @keyframes show {
    from {
      opacity: 0;
      transform: translateY(-0.5rem);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
  animation: show 0.2s linear forwards;

  .field-error {
  }

  &:has(.field-error:empty) {
    display: none;
  }
`;

export const StyledLabel = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 0.25rem;
  border-radius: 4px;
  transition: background-color 0.2s ease-in-out;

  input {
    border: 0px;
    clip: rect(0px, 0px, 0px, 0px);
    clip-path: inset(50%);
    height: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0px;
    position: absolute;
    width: 1px;
    white-space: nowrap;
  }

  &:hover:not(label[data-disabled="true"] &) {
    background-color: rgba(0, 0, 0, 0.02);
  }

  label[data-disabled="true"] & {
    opacity: 0.6;
    cursor: not-allowed;
  }

  label[data-focused="true"] & {
    background-color: rgba(0, 0, 0, 0.04);
  }

  label[data-focus-visible="true"] & {
    .checkbox-item {
      outline: 2px solid var(--focus-ring-color, #0066cc);
      outline-offset: 2px;
    }
  }
`;
